import objectPath from 'object-path'

export const getTooltip1D = (seriename, { seriesIndex, config, globals }) => {
  let tooltip = ''
  let serieIndex = seriesIndex
  let showValueY = config?.tooltip?.y.showValue
  if (showValueY) {
    let prefixY = config?.tooltip?.y.prefixValue || ''
    let suffixY = config?.tooltip?.y.suffixValue || ''
    let serie = globals?.series[serieIndex]
    tooltip += prefixY + serie + suffixY + ` `
  }
  let showPercentY = config?.tooltip?.y.showPercent
  if (showPercentY) {
    let prefixY = config?.tooltip?.y.prefixPercent || ''
    let suffixY = config?.tooltip?.y.suffixPercent || ''
    let percent = globals?.seriesPercent[serieIndex][0]
    tooltip += prefixY + percent.toFixed(0) + `%` + suffixY
  }
  return tooltip
}

export const getToolTipX = (seriename, option) => {
  let { dataPointIndex, w } = option
  let showAxisX = w?.config?.tooltip?.x.show
  if (showAxisX) {
    return (
      objectPath.get(w?.config, ['options', 'categories', dataPointIndex]) ||
      objectPath.get(w?.globals, ['categoryLabels', dataPointIndex]) ||
      seriename
    )
  }
  return ''
}

export const getToolTipY = (seriename, option) => {
  let { seriesIndex, dataPointIndex, w } = option
  let tooltipConfig = w?.config?.tooltip
  let globals = w?.globals
  let tooltip = seriename
  let valueY = tooltipConfig?.y.valueY
  if (valueY === 'percent') {
    let percent = globals?.seriesPercent[seriesIndex][dataPointIndex] || 0
    tooltip = percent.toFixed(0) + '%'
  }
  return tooltip
}

export const getTooltip = (chartKey) => {
  let tooltip1D = ['donut', 'pie']
  let tooltip2D = ['line', 'area', 'column', 'bar']
  if (tooltip1D.includes(chartKey)) {
    return [
      {
        formatterKey: `tooltip.y.formatter`,
        formatter: (seriesName, opts) => getTooltip1D(seriesName, opts),
      },
    ]
  }
  if (tooltip2D.includes(chartKey)) {
    return [
      {
        formatterKey: `tooltip.x.formatter`,
        formatter: (seriesName, opts) => getToolTipX(seriesName, opts),
      },
      {
        formatterKey: `tooltip.y.formatter`,
        formatter: (seriesName, opts) => getToolTipY(seriesName, opts),
      },
    ]
  }
  return null
}
